import { personSelectionRowFieldConfig } from '../../person/fields/utils/personFieldsUtils';
import { Locale } from '../../../../localization/LocalizationKeys';
import { PersonSelectionRowCriteriaOrder } from '../../../../gql/typings';

export const personSelectionRowSelectionDescriptionFieldConfig = personSelectionRowFieldConfig(
  'selectionDescription',
  [
    'selectionRow.id',
    'selectionRow.group.id',
    'selectionRow.group.selection.id',
    'selectionRow.group.selection.description',
  ],
  ({ localization }) => ({
    title: localization.formatMessage(Locale.Attribute.Selection_description),
    sorting: {
      ascend: PersonSelectionRowCriteriaOrder.SELECTION_DESCRIPTION_ASC,
      descend: PersonSelectionRowCriteriaOrder.SELECTION_DESCRIPTION_DESC,
    },
    render: record => record.selectionRow?.group.selection.description ?? localization.formatMessage(Locale.General.Unknown),
  }),
);
